import { TYPES } from '../flattenTree/utils/consts';
import { deepCopy } from '../objectUtils';
import { toUrlFormat } from '../treeVisitors';
import { addGuidesToNodesVisitor } from '../treeVisitors/createGuideTags';

export const setInitialSortOrderOnGuides = (items) => {
  /*
    We do this process so that the guides order in the menu will be the same as the customer defined in the `guides.json` file.
  */
  items.forEach((item, itemIndex) => {
    item.sortOrder = itemIndex;
    item.articles.forEach((article, articleIndex) => {
      article.sortOrder = articleIndex;
      article.extra = { isArticlesSectionGuide: true };
    });
  });
};

export const convertArticlesSectionItemToNode = (
  { title, articles },
  sortOrder
) => ({
  data: {
    propType: TYPES.ARTICLES_CATEGORY,
    name: title,
    urlFormat: toUrlFormat(title),
    relatedGuides: articles,
    sortOrder,
  },
});

export const createGuidesTree = (items) => {
  const _items = deepCopy(items);
  setInitialSortOrderOnGuides(_items);
  return _items.reduce((tree, item, itemIndex) => {
    const titleToKey = `/${toUrlFormat(item.title)}`;
    tree[titleToKey] = convertArticlesSectionItemToNode(item, itemIndex);
    addGuidesToNodesVisitor(tree[titleToKey], true);
    return tree;
  }, {});
};
